"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withDecimals = void 0;
var withDecimals = function (number, decimals) {
    if (number === undefined && typeof number === 'number') {
        throw Error('number is required and need to be of numeric type');
    }
    if (decimals === undefined && typeof decimals === 'number') {
        throw Error('decimals is required and need to be of numeric type');
    }
    if (decimals > 0) {
        return Number.parseFloat(number.toFixed(decimals));
    }
    return Number.parseInt(number, 10);
};
exports.withDecimals = withDecimals;
//# sourceMappingURL=decimals.js.map